import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zhCN from './locales/zh/translation.json';
import enUS from './locales/en/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'zh',
    fallbackLng: 'en',
    debug: false,
    supportedLngs: ['zh', 'en'],
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie']
    },
    interpolation: {
      escapeValue: false
    },
    resources: {
      zh: {
        translation: zhCN
      },
      en: {
        translation: enUS
      }
    }
  });

// 添加单复数处理
i18n.services.formatter.add('units', (value, lng, options) => {
  const count = options.count;
  const translationKey = options.keySeparator ? options.key : options.defaultValue;
  const language = lng || i18n.language;

  if (translationKey === 'overs') {
    if (language === 'zh') {
      return `${count}回合`;
    } else {
      return `${count} Ov`;
    }
  } else if (translationKey === 'balls') {
    if (language === 'zh') {
      return `${count}球`;
    } else {
      return count === 1 ? `${count} ball` : `${count} balls`;
    }
  } else if (translationKey === 'runs') {
    if (language === 'zh') {
      return `${count}分`;
    } else {
      return count === 1 ? `${count} run` : `${count} runs`;
    }
  }
  return value;
});

export default i18n;
